import {
  IActionRules,
  INotificationFormMode,
  NotificationFormModeEnum,
} from "./interface";

export const actionsConfig: Record<INotificationFormMode, IActionRules> = {
  [NotificationFormModeEnum.CREATE]: {
    showCancel: true,
    showPreview: true,
    showSubmit: true,
    submitLabel: "Criar",
  },
  [NotificationFormModeEnum.EDIT]: {
    showCancel: true,
    showPreview: true,
    showSubmit: true,
    submitLabel: "Salvar",
  },
  [NotificationFormModeEnum.VIEW]: {
    showCancel: true,
    showPreview: true,
    showSubmit: false,
  },
};
